import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  return <main id="main" className="main"><div className="shopify-policy__container">
    <div className="shopify-policy__title"><h1>Privacy policy</h1></div>
    <div className="shopify-policy__body"><div className="rte">
      <p>Last updated: September 14, 2026</p>
      <p>This policy explains how slayfulpawsco collects, uses, and protects information when you browse the site, contact us, or place an order.</p>
      <h2>Information we collect</h2>
      <p>We may collect contact details, delivery and billing details, order selections, messages you send, and limited technical data needed to operate and secure the site. Payment details should be handled by the payment service presented at checkout and are not intentionally stored in this site's browser storage.</p>
      <h2>How we use information</h2>
      <p>We use information to provide requested services, process and deliver orders, answer questions, prevent misuse, maintain records, and meet legal obligations. Marketing messages are sent only where permitted, and you may unsubscribe from them.</p>
      <h2>Sharing and retention</h2>
      <p>Information may be shared with service providers only as needed for hosting, payment, delivery, support, security, or legal compliance. We keep information only for as long as reasonably necessary for these purposes.</p>
      <h2>Your choices and rights</h2>
      <p>Depending on your location, you may request access, correction, deletion, restriction, portability, or an objection to certain uses. We may need to verify your identity and may retain records where the law requires it.</p>
      <h2>Cookies and local storage</h2>
      <p>The cart uses local browser storage. See our <Link to="/cookies">Cookie Policy</Link> for details and browser controls.</p>
      <h2>Children and international use</h2>
      <p>The site is not directed to children below the age at which they can independently consent to data processing. Information may be processed in countries with different privacy rules, subject to safeguards required by applicable law.</p>
      <h2>Security and changes</h2>
      <p>We use reasonable safeguards, but no online transmission or storage method is completely secure. We may update this policy when our practices or legal obligations change and will post the revised date here.</p>
      <h2>Contact</h2>
      <p>Email: <a href="mailto:phase@slayfulpawsco.cloud">phase@slayfulpawsco.cloud</a></p>
      <p>Mail: Forest Inc., 390 Lofton Rd NW, Atlanta, GA 30309 US</p>
    </div></div>
  </div></main>;
}

export default Privacy;
